import React, { Component } from 'react';
import { Link } from 'react-router-dom';
// import Ico from './iconBox';

// import HomeBlog from '../assets/images/blog_1.jpg';
// import person1 from '../assets/images/person_1.jpg';
// import person2 from '../assets/images/person_2.jpg';
// import person3 from '../assets/images/person_3.jpg';
// import person4 from '../assets/images/person_4.jpg';

class Home extends Component {
    state = {

    }
    componentDidMount(){
        window.scrollTo(0, 0)

    }
    render() {
        return (
            <div>
            
 


<br/>



<div className="container">
    <div className="row">
        <div className="col-12">
  
  












 <h1>Partner with YOVHO</h1>
  <p>Unlock Your Property’s True Potential</p>
  <p>Whether you own a hotel, guest house, apartment, or hostel, YOVHO empowers you to grow your business with ease. Join our global platform and benefit from powerful tools, seamless operations, and unmatched visibility.</p>

  <h2>Why Partner with YOVHO?</h2>
  <ul>
    <li><strong>Maximize Revenue:</strong> Dynamic pricing, smart distribution, and direct bookings to increase occupancy and profit.</li>
    <li><strong>Boost Online Presence:</strong> Get listed across top travel platforms and search engines—managed for you.</li>
    <li><strong>Simplify Operations:</strong> From guest management to housekeeping coordination, we help streamline daily tasks.</li>
    <li><strong>Reach Global Guests:</strong> Attract travelers from around the world with trusted br/anding and marketing support.</li>
    <li><strong>Build a Trusted Br/and:</strong> Become part of a recognizable and reliable hospitality network loved by guests and locals alike.</li>
  </ul>

  <h2>Who Can Join?</h2>
  <ul>
    <li>Hotel Owners</li>
    <li>Guest House Operators</li>
    <li>Apartment Hosts</li>
    <li>Hostel Managers</li>
  </ul>

  <h2>Turn Your Property into a Profitable Hospitality Business</h2>
  <p>Whether you own a hotel, guest house, apartment, or hostel, YOVHO helps you unlock the full earning potential of your property—quickly and efficiently.</p>

  <h2>Why Partner with Us?</h2>
  <ul>
    <li><strong>Start Earning Within Days:</strong> Once onboarded, your property can begin generating revenue in just a few days through our fast-track setup and instant booking systems.</li>
    <li><strong>Professional Onboarding & Training:</strong> We offer full training and guidance for you and your staff to ensure a smooth transition and successful operations.</li>
    <li><strong>Trained & Professional Support Staff:</strong> Need help managing your property? YOVHO can provide experienced, well-trained staff to support you in delivering a seamless guest experience.</li>
    <li><strong>Maximize Revenue:</strong> Our dynamic pricing tools and wide distribution network are designed to boost your income and increase occupancy.</li>
    <li><strong>Expand Your Reach:</strong> Get visibility across major travel platforms and attract guests from around the world.</li>
    <li><strong>Simplify Operations:</strong> From housekeeping to guest check-ins, we streamline your day-to-day with integrated tech and operational support.</li>
    <li><strong>Trusted Br/and Association:</strong> Become part of a globally trusted br/and known for quality and reliability.</li>
  </ul>

  <h2>Who Can Join?</h2>
  <ul>
    <li>Hotel Owners</li>
    <li>Guest House Operators</li>
    <li>Apartment Hosts</li>
    <li>Hostel Managers</li>
  </ul>

  <h2>Contact Us</h2>
  <p><strong>Phone:</strong><br/>
  UAE: +971 55 556 2053<br/>
  Pakistan: +92 316 661 1136</p>

  <p><strong>Email:</strong><br/>
  <a href="mailto:investors@yovho.com">investors@yovho.com</a></p>







        </div>
    </div>
</div>

















        
          </div>
        )
    }
}

export default Home;